<template>
    <nav class="sub-sub-menu-nav">
        <ul class="sub-sub-menu">
            <li class="sub-sub-menu-item">
                <span class="text-sm md:text-base font-bold text-primary m-0 my-2 sm:my-0 px-4 md:px-6">
                    Reports
                </span>
            </li>
            <li class="sub-sub-menu-item">
                <router-link
                    class="sub-sub-menu-item-link"
                    :to="{ name: 'SubgroupAdminReportsCertificateExpiries' }"
                    @click.prevent="gotoRoute({ name: 'SubgroupAdminReportsCertificateExpiries' })"
                    >Certificate Expiry</router-link
                >
            </li>
            <li class="sub-sub-menu-item">
                <router-link
                    class="sub-sub-menu-item-link"
                    :to="{ name: 'SubgroupAdminReportsCourseResults' }"
                    @click.prevent="gotoRoute({ name: 'SubgroupAdminReportsCourseResults' })"
                    >Course Results</router-link
                >
            </li>
            <li class="sub-sub-menu-item">
                <router-link
                v-if="subgroupAdminLevel()!=='LOW'"
                    class="sub-sub-menu-item-link"
                    :to="{ name: 'SubgroupAdminReportsLicenceLevels' }"
                    @click.prevent="gotoRoute({ name: 'SubgroupAdminReportsLicenceLevels' })"
                    >Low Licence Levels</router-link
                >
            </li>
            <li class="sub-sub-menu-item">
                <router-link
                    class="sub-sub-menu-item-link"
                    :to="{ name: 'SubgroupAdminReportsAssessmentsDue' }"
                    @click.prevent="gotoRoute({ name: 'SubgroupAdminReportsAssessmentsDue' })"
                    >Assessments Due</router-link
                >
            </li>
        </ul>
    </nav>
</template>
<script>
export default {
    methods: {
        gotoRoute(route) {
            this.$router.push(route);
            this.$store.commit("closeMobileMenu");
        }
    }
};
</script>